const myLib = require('../lib/MyLib');
/* Giao tiep voi API ve du lieu su kien */
export function chuanHoaSukien(action, sukien) {
  switch (action) {
    case "header": //save thong tin ban dau ve su kien
      sukien.TenSK = (sukien.TenSK ? sukien.TenSK : '').toUpperCase();
      sukien.SoHoSo = (sukien.SoHoSo ? sukien.SoHoSo : '').toUpperCase();
      sukien.ThoiGian = sukien.ThoiGian ? new Date(sukien.ThoiGian.setMilliseconds(0)) : sukien.ThoiGian;
      break;
    case 'tainan': //save thong tin tai nan cua su kien
      sukien.ThoiGianBaoNan = sukien.ThoiGianBaoNan ? new Date(sukien.ThoiGianBaoNan.setMilliseconds(0)) : sukien.ThoiGianBaoNan;
      sukien.ThoiGianBiNan = sukien.ThoiGianBiNan ? new Date(sukien.ThoiGianBiNan.setMilliseconds(0)) : sukien.ThoiGianBiNan;
      break;
    case 'phuongtien': //thong tin ve phuong tien
      sukien.TenTau = myLib.toString(sukien.TenTau).toUpperCase();
      sukien.HoHieu = myLib.toString(sukien.HoHieu).toUpperCase();
      break;
    case 'tinhchat': //tinh chat tai nan
      break;
    case 'dieudong':
      sukien.TenTau = myLib.toString(sukien.TenTau).toUpperCase();
      break;
  }
  return sukien;
}
//chuyen doi gia kieu du lieu khi query tu server ve client de edit
export function chuyenDoi(sukien) {
  sukien.ThoiGian = myLib.fromServerTime(sukien.ThoiGian); //server dang hieu la local nen phai chuyen thanh utc
  sukien.MaNguonTin = {value: sukien.MaNguonTin, label: sukien.TenDoiTac};
  //thong tin tai nan
  if(sukien.ThoiGianBaoNan !== undefined && sukien.ThoiGianBaoNan !== null) {
    sukien.ThoiGianBaoNan = myLib.fromServerTime(sukien.ThoiGianBaoNan);
  }
  if(sukien.ThoiGianBiNan !== undefined && sukien.ThoiGianBiNan !== null) {
    sukien.ThoiGianBiNan = myLib.fromServerTime(sukien.ThoiGianBiNan);
  }
  if(sukien.KetThuc !== undefined && sukien.KetThuc !== null) {
    sukien.KetThuc = myLib.fromServerTime(sukien.KetThuc);
  }
  if(sukien.LoaiTB !== undefined && sukien.LoaiTB !== null) {
    sukien.LoaiTB = {value: sukien.LoaiTB, label: sukien.TenLoaiTB};
  }
  if(sukien.MaVung !== undefined && sukien.MaVung !== null) {
    sukien.MaVung = {value: sukien.MaVung, label: sukien.TenVung};
  }
  if(sukien.MaKV !== undefined && sukien.MaKV !== null) {
    sukien.MaKV = {value: sukien.MaKV, label: sukien.TenKhuVuc};
  }
  if(sukien.MaTN !== undefined && sukien.MaTN !== null) {
    sukien.MaTN = {value: sukien.MaTN , label: sukien.TenTaiNan}
  }
  if(sukien.PhoiHopQT_MaQG !== undefined && sukien.PhoiHopQT_MaQG !== null) {
    sukien.PhoiHopQT_MaQG = {value: sukien.PhoiHopQT_MaQG, label: sukien. TenQuocGia_PhoiHopQT };
  }
  if(sukien.PhoiHopQT_MaDoiTac !== undefined && sukien.PhoiHopQT_MaDoiTac !== null) {
    sukien.PhoiHopQT_MaDoiTac = {value: sukien.PhoiHopQT_MaDoiTac, label: sukien.PhoiHopQT_TenDoiTac };
  }
  return sukien;
}
//chuyen doi du lieu phuong tien tu server sang dang client de edit
export function chuyenDoiPhuongTien(phuongtien) {
  if(phuongtien.MaQG !== undefined && phuongtien.MaQG !== null) {
    phuongtien.MaQG = {value: phuongtien.MaQG, label: phuongtien.TenQuocGia};
  }
  if(phuongtien.LoaiTau !== undefined && phuongtien.LoaiTau !== null) {
    phuongtien.LoaiTau = {value: phuongtien.LoaiTau, label: phuongtien.TenLoaiTau};
  }
  return phuongtien;
}
export function chuyenDoiDieuDong(phuongtien) {
  if(phuongtien.NgayRoi !== undefined && phuongtien.NgayRoi !== null) {
    phuongtien.NgayRoi = myLib.fromServerTime(phuongtien.NgayRoi);
  }  
  if(phuongtien.NgayKetThuc !== undefined && phuongtien.NgayKetThuc !== null) {
    phuongtien.NgayKetThuc = myLib.fromServerTime(phuongtien.NgayKetThuc);
  }  
  if(phuongtien.ThoiGianVT !== undefined && phuongtien.ThoiGianVT !== null) {
    phuongtien.ThoiGianVT = myLib.fromServerTime(phuongtien.ThoiGianVT);
  }  
  return phuongtien;
}
/*Validate thong tin ve su kien, tra ve thong tin bao gom truong thong tin co van de va hien thi thong bao neu co */
export function validate(action, sukien) {
  var result = {error: false};
  switch(action) {
    case 'header': //tac dong den header
      if (myLib.isEmpty(sukien.ThoiGian)) {
        result.error = true;
        result.ThoiGian = {error: true, trangthai: 'Chưa có thời gian'};
      }
      if (myLib.isEmpty(sukien.TenSK)) {
        result.error = true;
        result.TenSK = {error: true, trangthai: 'Chưa có tên sự vụ!'};
      }
      if (myLib.isEmpty(sukien.SoHoSo)) {
        result.error = true;
        result.SoHoSo = {error: true, trangthai: 'Chưa có mã hồ sơ sự vụ'};
      }
      break;
    case 'tainan': //thong tin ve tai nan
      if (myLib.toString(sukien.MaNguonTin) === '' || myLib.toString(sukien.MaNguonTin) === '0') {
        result.error = true;
        result.MaNguonTin = {error: true, trangthai: 'Chưa có nguồn tin'};
      }
      if (myLib.toString(sukien.ThoiGianBaoNan) === '') {
        result.error = true;
        result.ThoiGianBaoNan = {error: true, trangthai: 'Chưa có thời gian báo nạn'};
      }
      if (myLib.toString(sukien.ThoiGianBiNan) === '') {
        result.error = true;
        result.ThoiGianBiNan = {error: true, trangthai: 'Chưa có thời gian bị nạn'};
      }
      if (myLib.toString(sukien.LoaiTB) === '') {
        result.error = true;
        result.LoaiTB = {error: true, trangthai: 'Chưa có loại thiết bị'};
      }
      break;
    case 'phuongtien': //thong tin ve phuong tien
      if (myLib.toString(sukien.TenTau) === '') {
        result.error = true;
        result.TenTau = {error: true, trangthai: 'Chưa có tên tàu '};
      }
      if (myLib.toString(sukien.LoaiTau) === '') {
        result.error = true;
        result.LoaiTau = {error: true, trangthai: 'Chưa có loại tàu'};
      }
      if (myLib.toString(sukien.MaQG) === '') {
        result.error = true;
        result.MaQG = {error: true, trangthai: 'Chưa có quốc tịch'};
      }      
      break;
      case 'dieudong': //thong tin ve phuong tien dieu dong
      if (myLib.toString(sukien.TenTau) === '') {
        result.error = true;
        result.TenTau = {error: true, trangthai: 'Chưa có tên tàu '};
      }
      if (myLib.toString(sukien.NgayRoi) === '') {
        result.error = true;
        result.NgayRoi = {error: true, trangthai: 'Chưa có ngày rời bến'};
      }
      break;      
    case 'tinhchat': //tinh chat tai nan
      if (myLib.toString(sukien.MaTN) === '') {
        result.error = true;
        result.MaTN = {error: true, trangthai: 'Chưa có tính chất tai nạn'};
      }
      break;
    case 'ketqua':
      if(sukien.TrangThai + '' === '1' && myLib.toString(sukien.KetThuc) !== '') {
        result.error = true;
        result.KetThuc = {error: true, trangthai: 'Đang xử lý thì không có thời gian kết thúc'};
      }
      if(sukien.TrangThai + '' === '2' && myLib.toString(sukien.KetThuc) === '') {
        result.error = true;
        result.KetThuc = {error: true, trangthai: 'Chưa có thời gian kết thúc'};
      }
      break;
  }
  return result;
}